export const CATEGORIES = ['necessary', 'measurement', 'marketing'] as const;
export type Category = (typeof CATEGORIES)[number];

export const TOGGLEABLE_CATEGORIES: ReadonlyArray<Category> = [
  'measurement',
  'marketing',
];

export const CONSENT_POLICY_VERSION = '2026-06-02' as const;

/**
 * Code identifier per registered cookie. Each value has a matching translation
 * entry under `t.consent.statement.cookies[key]` (`.purpose`, etc.) — see the
 * cookies page (Task 9) for the render path.
 */
export const COOKIE_KEYS = [
  'workosSession',
  'c15tConsent',
  'phPosthog',
  'phWindowId',
] as const;
type CookieKey = (typeof COOKIE_KEYS)[number];

/**
 * Structural retention value. The cookie statement renders this via
 * `formatRetention(retention)` (see `format-retention.ts`) which uses
 * `Intl.DurationFormat` for duration objects and the localised "Sessie"
 * translation for the session marker — so no per-locale literals live here.
 */
export type Retention = 'session' | { years?: number; months?: number; days?: number };

export type CookieRow = {
  /** Code key — looks up purpose copy in `t.consent.statement.cookies[key]`. */
  key: CookieKey;
  /** Actual cookie / storage key written by the SDK. Not translated. */
  name: string;
  storage: 'cookie' | 'localStorage' | 'sessionStorage';
  category: Category;
  /** Provider label — proper noun (e.g. "WorkOS", "PostHog (EU)"). Not translated. */
  provider: string;
  retention: Retention;
};

export const COOKIE_TABLE: ReadonlyArray<CookieRow> = [
  {
    key: 'workosSession',
    name: 'workos-session',
    storage: 'cookie',
    category: 'necessary',
    provider: 'WorkOS',
    retention: 'session',
  },
  {
    key: 'c15tConsent',
    name: 'c15t-consent',
    storage: 'cookie',
    category: 'necessary',
    provider: 'noma-eco',
    retention: { years: 1 },
  },
  {
    key: 'phPosthog',
    name: 'ph_<api_key>_posthog',
    storage: 'localStorage',
    category: 'measurement',
    provider: 'PostHog (EU)',
    retention: { years: 1 },
  },
  {
    key: 'phWindowId',
    name: 'ph_<api_key>_window_id',
    storage: 'sessionStorage',
    category: 'measurement',
    provider: 'PostHog (EU)',
    retention: 'session',
  },
];
